import { createGridLayout, createGridItem } from "../../../../store/global/gridlayout";
import { getIntegerRange } from "../../../../utility";

export const productGridItemRouteMap = {
  'overview': getIntegerRange(0, 5),
  'tracks': getIntegerRange(6, 8),
  'info': getIntegerRange(9, 12),
  'costs': getIntegerRange(13, 15),
  'other_income': getIntegerRange(16, 17),
  'royalty': getIntegerRange(18, 20),
  'sales': getIntegerRange(21, 22),
  'stock': getIntegerRange(23, 27),
  'specials': getIntegerRange(28, 31),
  'metadata': getIntegerRange(32, 33),
};


export const productDetailsGrid = createGridLayout({
  layout: [
    createGridItem({
      "x": 0,
      "y": 0,
      "w": 30,
      "h": [
        12.5,
        16
      ],
      "i": "product_setup"
    }),
    createGridItem({
      "x": 30,
      "y": 0,
      "w": 30,
      "h": [
        10.3,
        22
      ],
      "i": "advanced_product_setup"
    }),
    createGridItem({
      "x": 30,
      "y": 10.3,
      "w": 30,
      "h": 4.7,
      "i": "stock_location"
    }),
    createGridItem({
      "x": 0,
      "y": 12.5,
      "w": 30,
      "h": 15,
      "i": "prices"
    }),
    createGridItem({
      "x": 30,
      "y": 15,
      "w": 30,
      "h": 15,
      "i": "submenu_GROUPS"
    }),
    createGridItem({
      "x": 0,
      "y": 25.3,
      "w": 60,
      "h": 15,
      "i": "only_tracks"
    }),
    createGridItem({
      "x": 0,
      "y": 30,
      "w": 60,
      "h": 13,
      "i": "accounts"
    }),
    createGridItem({
      "x": 0,
      "y": 43,
      "w": 30,
      "h": 10,
      "i": "notes"
    }),
    createGridItem({
      "x": 0,
      "y": 53,
      "w": 60,
      "h": 5,
      "i": "tab_title_tracks"
    }),
    createGridItem({
      "x": 0,
      "y": 58,
      "w": 60,
      "h": 13,
      "i": "tracklisting"
    }),
    createGridItem({
      "x": 0,
      "y": 71,
      "w": 60,
      "h": 10,
      "i": "GEMA"
    }),
    createGridItem({
      "x": 0,
      "y": 86,
      "w": 60,
      "h": 5,
      "i": "tab_title_infos"
    }),
    createGridItem({
      "x": 0,
      "y": 91,
      "w": 35,
      "h": 11.6,
      "i": "product_information"
    }),
    createGridItem({
      "x": 35,
      "y": 91,
      "w": 25,
      "h": 11.6,
      "i": "related_files"
    }),
    createGridItem({
      "x": 0,
      "y": 102.6,
      "w": 35,
      "h": 21,
      "i": "artwork_cover"
    }),
    createGridItem({
      "x": 0,
      "y": 123.6,
      "w": 60,
      "h": 4,
      "i": "tab_title_costs"
    }),
    createGridItem({
      "x": 0,
      "y": 127.6,
      "w": 60,
      "h": 3,
      "i": "cost_account_all"
    }),
    createGridItem({
      "x": 0,
      "y": 130.6,
      "w": 60,
      "h": 20,
      "i": "related_costs"
    }),
    createGridItem({
      "x": 0,
      "y": 150.6,
      "w": 60,
      "h": 5,
      "i": "other_income"
    }),
    createGridItem({
      "x": 0,
      "y": 155.6,
      "w": 60,
      "h": 20,
      "i": "related_other_income"
    }),
    createGridItem({
      "x": 0,
      "y": 175.6,
      "w": 60,
      "h": 5,
      "i": "royalty"
    }),
    createGridItem({
      "x": 0,
      "y": 180.6,
      "w": 60,
      "h": 5,
      "i": "royalty_btn"
    }),
    createGridItem({
      "x": 0,
      "y": 185.6,
      "w": 60,
      "h": 15,
      "i": "royalties"
    }),
    createGridItem({
      "x": 0,
      "y": 200.6,
      "w": 60,
      "h": 5,
      "i": "sales"
    }),
    createGridItem({
      "x": 0,
      "y": 205.6,
      "w": 60,
      "h": 20,
      "i": "ds_sales"
    }),
    createGridItem({
      "x": 0,
      "y": 225.6,
      "w": 60,
      "h": 5,
      "i": "stock"
    }),
    createGridItem({
      "x": 0,
      "y": 230.6,
      "w": 30,
      "h": 30,
      "i": "stock_levels"
    }),
    createGridItem({
      "x": 30,
      "y": 230.6,
      "w": 30,
      "h": 13,
      "i": "manufacturing"
    }),
    createGridItem({
      "x": 30,
      "y": 243.6,
      "w": 30,
      "h": 13,
      "i": "open_orders"
    }),
    createGridItem({
      "x": 30,
      "y": 256.6,
      "w": 30,
      "h": 13,
      "i": "backorders"
    }),
    createGridItem({
      "x": 0,
      "y": 269.6,
      "w": 60,
      "h": 5,
      "i": "specials"
    }),
    createGridItem({
      "x": 0,
      "y": 274.6,
      "w": 35,
      "h": 20,
      "i": "country_restrictions"
    }),
    createGridItem({
      "x": 35,
      "y": 274.6,
      "w": 25,
      "h": 20,
      "i": "manual_matches"
    }),
    createGridItem({
      "x": 0,
      "y": 294.6,
      "w": 30,
      "h": 6.5,
      "i": "harry_fox"
    }),
    createGridItem({
      "x": 0,
      "y": 301.1,
      "w": 60,
      "h": 5,
      "i": "metadata"
    }),
    createGridItem({
      "x": 0,
      "y": 306.1,
      "w": 30,
      "h": 20,
      "i": "meta_data"
    }),
  ]
});